/**
 * Product identifiers grouped by vendor ID.
 * @module
 * @internal
 */
export { ARMOR3_LEVEL_UP_COBRA_PRODUCT_ID } from './armor3LevelUp'
export { GAMESTOP_PS4_FUN_CONTROLLER_PRODUCT_ID } from './gamestop'
export { HORI_MINI_WIRED_GAMEPAD_PRODUCT_ID, HORI_FIGHTING_COMMANDER_PRODUCT_ID } from './hori'
export { MULTILASER_WARRIOR_JOYPAD_PRODUCT_ID, STEELPLAY_METALTECH_P4_PRODUCT_ID } from './multilaserSteelplay'
export { NACON_REVOLUTION_PRO_PRODUCT_ID, NACON_REVOLUTION_PRO_2_PRODUCT_ID, NACON_REVOLUTION_UNLIMITED_PRO_PRODUCT_ID } from './nacon'
export {
  DUALSHOCK4_V1_PRODUCT_ID,
  DUALSHOCK4_V2_PRODUCT_ID,
  DUALSHOCK4_WIRELESS_ADAPTER_PRODUCT_ID,
  STRIKE_PACK_FPS_DOMINATOR_PRODUCT_ID
} from './playstation'
export {
  RAZER_RAIJU_PS4_PRODUCT_ID,
  RAZER_RAIJU_TOURNAMENT_USB_PRODUCT_ID,
  RAZER_RAIJU_ULTIMATE_USB_PRODUCT_ID,
  RAZER_RAIJU_ULTIMATE_BLUETOOTH_PRODUCT_ID
} from './razer'
export { SCUF_VANTAGE_PRODUCT_ID } from './scuf'
